






















import Vue from "vue";
import { RecordAny } from "@gemma/typescript-types";
import { GemmaError } from "@gemma/errors";
import URI from "urijs";
import { Form } from "@/utils/Form/Form";
import { validateEmailAddress, validatePassword } from "@timesheets/validators-common";
import { Accounts } from "@timesheets/routes-api-common";
import { ResetPassword } from "@timesheets/routes-app";
import "./scss";
import { setMetaDescription } from "@/utils/setMetaDescription";
import Common from "../Common/Index.vue";

export default Vue.extend({
  name: "LoginView",

  extends: Form,

  components: {
    Common,
  },

  data() {
    const query = this.$route.fullPath.split("?")[1];
    const route = Accounts.Login.Local + (query ? "?" + query : "");

    return {
      route,
      form: {
        canonicalName: this.$app.currentTenant ? this.$app.currentTenant.branding.names.currentCanonical : "Initialising...",
        emailAddress: null,
        password: null,
        rememberMe: false,
      },
    };
  },

  computed: {
    emailVerificationLink() {
      return ResetPassword.GetEmailVerificationByEmailAddress(this.form.emailAddress);
    },
  },

  mounted() {
    setMetaDescription("Login to your SaveTrees Online Timesheets account");
  },

  methods: {
    validate(form: RecordAny, errors: GemmaError[]) {
      validateEmailAddress(form.emailAddress, errors, undefined, "Login", { checkCasing: false });
      validatePassword(form.password, errors, undefined, "Login");
    },

    onSuccess(loginResponse: { route: string }) {
      if (window.location.search) {
        const dataMap = URI(window.location.href).search(true);
        if (dataMap.requestedRoute) {
          window.location.assign(dataMap.requestedRoute);
          return;
        }
      }

      window.location.assign(loginResponse.route);
    },
  },
});
